import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const LeaveTypeList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { leaveTypes, total, page } = data;

    return (
        <>
            <div className="table-responsive">
                <table className="table align-middle table-nowrap table-hover">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: 70 }}>#</th>
                            <th>Leave Details</th>
                            <th>Policy</th>
                            <th>Other Info</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leaveTypes?.map((item, index) => (
                            <tr key={index}>
                                <td style={{ color: "#2b5a7e", fontSize: 15, fontFamily: "nunito" }}>
                                    {index + 1 + (page - 1) * limit}
                                </td>

                                <td>
                                    <h5 className="font-size-14 mb-1 text-dark">{item.LEAVE_TYPE_NAME}</h5>
                                    <p className="text-muted mb-0">Code: <strong>{item.LEAVE_CODE}</strong></p>
                                    <p className="text-muted mb-0">Description: {item.DESCRIPTION}</p>
                                    <p className="text-muted mb-0">Gender: {item.GENDER_SPECIFIC}</p>
                                    <p className="text-muted mb-0">Cycle: {item.LEAVE_CYCLE_TYPE}</p>
                                </td>

                                <td>
                                    <p className="text-muted mb-0">Days: {item.NUMBER_OF_DAYS}</p>
                                    <p className="text-muted mb-0">Carry Forward: {item.IS_CARRY_FORWARD ? 'Yes' : 'No'}</p>
                                    <p className="text-muted mb-0">Encashable: {item.IS_ENCASHABLE ? 'Yes' : 'No'}</p>
                                    <p className="text-muted mb-0">Paid: {item.IS_PAID ? 'Yes' : 'No'}</p>
                                    <p className="text-muted mb-0">Approval Required: {item.REQUIRES_APPROVAL ? 'Yes' : 'No'}</p>
                                    <p className="text-muted mb-0">Attachment: {item.ATTACHMENT_REQUIRED ? 'Yes' : 'No'}</p>
                                </td>

                                <td>
                                    <p className="text-muted mb-0">Max/Month: {item.MAX_APPLICATIONS_PER_MONTH || '-'}</p>
                                    <p className="text-muted mb-0">
                                        Status: <span style={{ color: item.IS_ACTIVE ? "green" : "red" }}>
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </p>
                                    <p className="text-muted mb-0">
                                        Last Updated By: <strong>{item.MODIFIED_BY_NAME || '-'}</strong>
                                    </p>
                                </td>

                                <td>
                                    <ul className="list-inline font-size-20 contact-links mb-0">
                                        <li className="list-inline-item px-2">
                                            <Link
                                                to={{
                                                    pathname: constant.Authedcomponent.editLeaveTypeMasterData.url,
                                                    state: {
                                                        data: btoa(JSON.stringify(item)),
                                                        page: page
                                                    }
                                                }}
                                                title="Edit Leave Type"
                                            >
                                                <i className="bx bx-edit" />
                                            </Link>
                                        </li>
                                        <li className="list-inline-item px-2">
                                            <button
                                                className="btn btn-sm"
                                                style={{ color: item.IS_ACTIVE ? 'green' : '#ffc107', background: 'transparent', border: 'none' }}
                                                onClick={() => onChangeVisibility(item)}
                                                title="Toggle Status"
                                            >
                                                <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                            </button>
                                        </li>
                                    <li className="list-inline-item px-2"><AdminDeleteButton resource="leaveType" entryId={item.ID} label="leaveType" /></li>
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </>
    );
};

export default withRouter(LeaveTypeList);
